var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.28,5h5.44a1,1,0,0,1,1,1v.89a0,0,0,0,1,0,0H4.28a0,0,0,0,1,0,0V6A1,1,0,0,1,5.28,5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.72,
    y: 3,
    width: 2.56,
    height: 1.01,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.72,7.93V12.4a.64.64,0,0,0,.66.6h5.24a.64.64,0,0,0,.66-.6V7.93Zm1.61,4a.35.35,0,0,1-.35.35H6a.35.35,0,0,1-.34-.35V9A.34.34,0,0,1,6,8.69H6A.35.35,0,0,1,6.33,9Zm2,0a.35.35,0,0,1-.35.35H8a.35.35,0,0,1-.35-.35V9A.35.35,0,0,1,8,8.69H8A.35.35,0,0,1,8.36,9Zm2,0a.36.36,0,0,1-.36.35h0a.35.35,0,0,1-.35-.35V9A.35.35,0,0,1,10,8.69h0a.35.35,0,0,1,.36.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentDelete);
export default __webpack_public_path__ + "static/media/comment-delete.7a1caba30d67b8d5b912f98e1e0836a9.svg";
export { ForwardRef as ReactComponent };